<template>
    <!-- 审核控制台 -->
    <div>
        <order-search
                :count-data="countTagData"
                :handle-success="handleSearchResponse"
                :refresh-url="url"
                :handle-re-fresh="initOrderResponse"
        >
            <el-col :span="2" style="border-left: #e9e9e9 solid 2px">
                <el-button @click="moreVerifyShow=true" type="primary" size="mini">批量审核</el-button>
            </el-col>
            <el-col :span="1">
                <i v-show="loading" class="el-icon-loading"></i>
            </el-col>
            <el-col :span="2">
                <div>
                    <el-tag type="info" size="small">订单数量:{{ orders.length }} / {{ count }}</el-tag>
                </div>
            </el-col>
        </order-search>
        <order-table :sort-url="url" @handlesort="initOrderResponse" :orders="orders" :select="true" ref="verifyTable"/>
        <next-foo :handle-response="handleNext" :no-more="noMore" :next-url="nextUrl"/>
        <!-- 批量审核面板 -->
        <el-dialog
                title="批量审核"
                :visible.sync="moreVerifyShow"
                width="30%"
                @close="initVerifyDialog"
        >
            <div style="text-align: left">
                <p v-if="moreVerifyShow">
                    <span><i class="el-icon-warning text-warning"></i> 共批量审核 {{ getSelectedRows().length }} 个订单</span>
                </p>
                <el-divider></el-divider>
                <el-progress v-show="showProcess" :percentage="percentage" :status="verifyStatus"></el-progress>

            </div>
            <span slot="footer" class="dialog-footer">
                 <i v-show="multipleVerifyLoading" class="el-icon-loading"></i>
    <el-button size="mini" @click="moreVerifyShow=false">取 消</el-button>

    <el-button size="mini" type="primary"
               @click="multipleVerify(successStatus)">批量通过</el-button>
    <el-button size="mini" type="danger"
               @click="multipleVerify(rejectStatus)">批量终结</el-button>
  </span>
        </el-dialog>

    </div>

</template>

<script>
    import OrderTable from "../components/orders/OrderTable";
    import OrderSearch from "../components/orders/OrderSearch"
    import NextFoo from "../components/NextFoo"
    import {mapGetters} from 'vuex'

    export default {
        name: "OrderVerify",
        data() {
            const defaultUrl = `${this.$const.orderListUrl}?status=VERIFY_ORDER&ordering=id`

            return {
                // 获取审核订单 api
                url: defaultUrl,
                loading: false,
                nextUrl: null,
                count: 0,
                moreVerifyShow: false,

                multipleVerifyLoading: false, // 批量审核标识符
                waitForFinish: 0,
                hasFinish: 0,
                successNum: 0,
                errorNum: 0,
                verifyStatus: 'warning',
                showProcess: false,
                successStatus: 'PASS',
                rejectStatus: 'END',
                percentage: 0,

                // 快捷标签的配置数据
                countTagData: {
                    countTagsUrl: `${this.$const.orderListUrl}verify_counts/`,
                    dataArr: [
                        {
                            count: 0,
                            loading: false,
                            tagName: '审核通过: ',
                            url: `${this.$const.orderListUrl}?verifyorder__result=PASS`,
                            countKey: 'pass_count',
                            type: 'success'
                        },

                        {
                            count: 0,
                            loading: false,
                            tagName: '终结订单: ',
                            url: `${this.$const.orderListUrl}?verifyorder__result=END`,
                            countKey: 'end_count',
                            type: 'danger'
                        },
                        {
                            count: 0,
                            loading: false,
                            tagName: '待处理: ',
                            url: defaultUrl,
                            countKey: 'wait_for_handle_count',
                            type: 'danger'
                        },
                        {
                            count: 0,
                            loading: false,
                            tagName: '加急: ',
                            url: `${defaultUrl}&urgent=true`,
                            countKey: 'urgent_count',
                            type: 'danger'
                        },
                    ],
                },
            }
        },
        components: {NextFoo, OrderSearch, OrderTable},
        computed: {
            noMore() {
                return !Boolean(this.nextUrl)
            },
            orders() {
                return this.verifyOrderData['orderList']
            },
            ...mapGetters([
                'verifyOrderData',
            ])
        },
        methods: {
            // 加载审核订单
            initOrders() {
                if (this.orders.length <= 0) {
                    this.loading = true
                    this.$getRequest(this.url)
                        .then((response) => {
                            this.loading = false
                            this.initOrderResponse(response)
                        })
                        .catch((error) => {
                            this.loading = false
                        })
                }
            },
            handleNext(response) {
                this.addOrderResponse(response)
            },
            handleSearchResponse(response) {
                this.setOrderResponse(response)
            },

            initOrderResponse(response) {
                this.setOrderResponse(response)
            },


            setOrderResponse(response) {
                const mutation = 'setVerifyOrders'
                this._handleOrderResponse(response, mutation)
            },

            addOrderResponse(response) {
                const mutation = 'addVerifyOrders'
                this._handleOrderResponse(response, mutation)
            },

            _handleOrderResponse(response, mutation) {
                const orders = response.data.results
                this.nextUrl = this.$utils.handleOrderUrl(response.data.next)
                this.count = response.data.count
                this.$store.commit(mutation, orders)
            },
            // 批量审核
            multipleVerify(status) {
                const rowsNum = this.getSelectedRows().length
                if (rowsNum <= 0) {
                    this.$message.warning('请选中订单后，再批量处理')
                    return
                }

                this.waitForFinish = rowsNum
                this.multipleVerifyLoading = true
                this.showProcess = true
                this.getSelectedRows().forEach(order => {
                    const url = `${this.$const.orderListUrl}${order.id}/verify_order/`
                    const data = {
                        verifyorder: {
                            result: status,
                        }
                    };

                    this.$postRequest(url, data)
                        .then((response) => {
                            this.addSuccessNum(response.data)
                        })
                        .catch((error) => {
                            this.addErrorNum()
                        })

                })
            },
            getSelectedRows() {
                return this.$refs.verifyTable.$refs.orderTable.selection
            },
            addErrorNum() {
                this.errorNum += 1
                this.hasFinish += 1
                this.percentage = (this.hasFinish / this.waitForFinish).toFixed(2) * 100
                if (this.waitForFinish === this.hasFinish) {
                    this.multipleVerifyLoading = false
                    this.verifyStatus = 'success'

                }
            },
            addSuccessNum(order) {
                this.$store.commit('deleteVerifyOrder', order)
                this.count -= 1
                this.successNum += 1
                this.hasFinish += 1
                this.percentage = (this.hasFinish / this.waitForFinish).toFixed(2) * 100
                if (this.waitForFinish === this.hasFinish) {
                    this.multipleVerifyLoading = false
                    this.verifyStatus = 'success'
                    this.$message.success(`共完成 ${this.successNum} / ${this.waitForFinish} 订单审核`)
                }
            },
            initVerifyDialog() {
                this.waitForFinish = 0
                this.hasFinish = 0
                this.successNum = 0
                this.errorNum = 0
                this.verifyStatus = 'warning'
                this.showProcess = false
                this.percentage = 0
            },
        },

        created() {
            this.initOrders()
        }
    }
</script>

<style scoped>
</style>